import { render, staticRenderFns } from "./RouteItemStops.vue?vue&type=template&id=77553afb"
import script from "./RouteItemStops.vue?vue&type=script&lang=js"
export * from "./RouteItemStops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports